module.exports = __webpack_public_path__ + "img/rhombus.01018467.jpg";